module.exports = __webpack_public_path__ + "static/warehouse-ea3729ccfd6b0f064599c327bfb54cf0.png";